import * as React from "react";

// material-ui
import makeStyles from "@material-ui/styles/makeStyles";
import Card from "@material-ui/core/Card";
import { CardContent, Grid } from "@material-ui/core";

import CircularProgress from "@material-ui/core/CircularProgress";
import Divider from "@material-ui/core/Divider";

// jaza-soft
import { PageFooter, PageHeader, Button, WithReduxForm, ReferenceInput, AutoCompleteInput, TextInput, BackButton, required } from "jazasoft";

// icons
import SaveIcon from "@material-ui/icons/Save";

// local
import CardHeader from "../../../components/CardHeader";
import MuiTable from "../../../components/MuiTable";
import Forbidden from "../../../components/Forbidden";

import { inputOptions } from "../../../utils/helpers";
import { ResourceId, Scope } from "../../../utils/privilege";
import hasPrivilege from "../../../utils/hasPrivilege";

import useCreateEdit from "./useCreateEdit";
import { useEntityPrivilege } from "../../../hooks";

const useStyles = makeStyles(theme => ({
  content: {
    margin: theme.spacing(3),
    marginTop: "0.5em"
  },
  marginVertical: {
    marginTop: "1em",
    marginBottom: "2em"
  },
  pageFooter: {
    "& > button": {
      marginRight: theme.spacing(2)
    }
  }
}));

const InvoiceCreate = props => {
  const { i18nKey, roles, hasAccess } = props;

  const { disableCreate } = useEntityPrivilege("GRN");
  const classes = useStyles();

  const { rows, columns, onSubmit, saving, onChange } = useCreateEdit({ ...props, page: "create" });

  let ffHandleSubmit;
  const handleSubmitRef = submit => {
    ffHandleSubmit = submit;
  };

  if (!hasPrivilege(roles, hasAccess, ResourceId.INVOICE, Scope.WRITE) || disableCreate) {
    return <Forbidden history={props.history} />;
  }

  return (
    <div>
      {/** Header Element */}
      <PageHeader title="resources.invoices.pageHeader.create" titleArgs={{ _: "Create Invoice" }} />

      {/* Main Content */}
      <div className={classes.content}>
        <WithReduxForm>
          {({ handleSubmit }) => (
            <div>
              {/* Basic Details */}
              <Card>
                <CardHeader title="Basic Details" />
                <Divider />
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={3}>
                      <ReferenceInput
                        i18nKey={i18nKey}
                        source="supplierId"
                        reference="suppliers"
                        pageSize={100}
                        validate={required()}
                        {...inputOptions(3)}>
                        <AutoCompleteInput fullWidth />
                      </ReferenceInput>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextInput i18nKey={i18nKey} source="invoiceNo" fullWidth validate={required()} {...inputOptions(3)} />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextInput i18nKey={i18nKey} source="erpInvoiceNo" fullWidth {...inputOptions(3)} />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              <Card style={{ marginTop: "1.5em" }}>
                <CardHeader title="Fabric Items" />
                <Divider />
                <MuiTable
                  columns={columns}
                  rows={rows}
                  component="div"
                  editable
                  editing
                  showEditableActions
                  enableRowAddition
                  rowAddCount={1}
                  handleSubmitRef={handleSubmitRef}
                  onSubmit={onSubmit}
                  onChange={onChange}
                  fontSize={16}
                  i18nKey="resources.fabricItems.fields"
                />
              </Card>

              {/* Footer */}
              <PageFooter className={classes.pageFooter}>
                <Button
                  label="Save"
                  color="primary"
                  variant="contained"
                  disabled={saving}
                  onClick={event => {
                    handleSubmit(() => {})();
                    ffHandleSubmit(event);
                  }}>
                  <SaveIcon />
                  {saving && <CircularProgress size={20} thickness={2} />}
                </Button>
                <BackButton label="Back" variant="outlined" color="primary" />
              </PageFooter>
            </div>
          )}
        </WithReduxForm>
      </div>
    </div>
  );
};

export default InvoiceCreate;
